import { protectorApiClient } from '@protector/api-client';
import type { V4Page } from '@protector/utils/types';
import type { FieldDayScoutingScore, PropertyLatestsScoutingScoresResponse, ScoutingScoreConfiguration } from './models.ts';

export async function getPropertyScoutingScoreConfigurations(propertyId?: string): Promise<ScoutingScoreConfiguration[]> {
  if (!propertyId) return [];
  const response = await protectorApiClient.request<unknown, V4Page<ScoutingScoreConfiguration>>({
    config: {
      method: 'GET',
      url: `/v1/properties/${propertyId}/scouting-score/configurations`
    }
  });
  return response.data.content;
}

export async function getFieldDayScoutingScore(
  propertyId?: string,
  fieldId?: string,
  startMoment?: string,
  endMoment?: string
): Promise<FieldDayScoutingScore | undefined> {
  if (!propertyId || !fieldId || !startMoment || !endMoment) return undefined;
  const response = await protectorApiClient.request<unknown, FieldDayScoutingScore>({
    config: {
      method: 'GET',
      url: `/v1/properties/${propertyId}/fields/${fieldId}/scouting-score`,
      params: { start: startMoment, end: endMoment }
    }
  });
  return response.data;
}

export async function getPropertyLatestsScoutingScores(
  propertyId?: string,
  seasonId?: string
): Promise<PropertyLatestsScoutingScoresResponse | undefined> {
  if (!propertyId) return undefined;
  const params: Record<string, string> = {};
  if (seasonId) {
    params.season_id = seasonId;
  }
  const response = await protectorApiClient.request<unknown, PropertyLatestsScoutingScoresResponse>({
    config: {
      method: 'GET',
      url: `/v1/properties/${propertyId}/scouting-score/latest`,
      params
    }
  });
  if (response.data !== null && typeof response.data === 'object' && 'content' in response.data) {
    return response.data;
  }
  return undefined;
}

export async function createScoutingScoreConfigurations(
  configurations: ScoutingScoreConfiguration[]
): Promise<ScoutingScoreConfiguration[]> {
  const response = await protectorApiClient.request<unknown, ScoutingScoreConfiguration[]>({
    config: {
      method: 'POST',
      url: '/v1/scouting-score/configurations/batch',
      data: configurations
    }
  });
  return response.data;
}

export async function deleteScoutingScoreConfiguration(configurationId: string, propertyId: string): Promise<number> {
  const response = await protectorApiClient.request({
    config: {
      method: 'DELETE',
      url: `/v1/properties/${propertyId}/scouting-score/configurations/${configurationId}`
    }
  });
  return response.status;
}
